import { memo, useEffect, useRef } from 'react'
import gsap from 'gsap'
import Carousel from '@/components/Carousel'
import useInView from '@/hooks/useInView'

const ProductGallery = ({
  className,
  items,
}) => {
  const $root = useRef()
  const { isInView } = useInView({
    start: 'top center',
    end: 'bottom 15%',
    once: false,
    trigger: $root.current,
  })

  useEffect(() => {
    // Gallery Animations
    gsap.to($root.current.children, {
      opacity: isInView ? 1 : 0,
      duration: 1.4,
      ease: 'power4.out',
    })
  }, [isInView])

  return (
    <div
      className={className}
      ref={$root}
    >
      <Carousel
        imagesList={items}
        parallax
        dots
        arrows
      />
    </div>
  )
}

ProductGallery.defaultProps = {
  items: [],
}

export default memo(ProductGallery)
